import { PropsWithChildren, ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';

export interface PromotionCardFCProps {
  strings: {
    title: ReactNode;
  };
  subtitle?: ReactNode;
  onClose: () => void;
}

export const PromotionCardFC = ({
  strings,
  subtitle,
  children,
}: PropsWithChildren<PromotionCardFCProps>) => {
  return (
    <Grid container spacing="24px">
      <Grid item xs={12} xl={12}>
        <Box paddingBottom={3}>
          <Typography variant="h3">{strings.title}</Typography>
        </Box>
        {subtitle && <Box paddingBottom={2}>{subtitle}</Box>}
        {children}
      </Grid>
    </Grid>
  );
};
